"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MailEvent", {
    enumerable: true,
    get: function() {
        return MailEvent;
    }
});
var MailEvent = /*#__PURE__*/ function(MailEvent) {
    MailEvent["COMMENT_CREATE"] = "COMMENT_CREATE";
    MailEvent["COMMENT_UPDATE"] = "COMMENT_UPDATE";
    MailEvent["BASE_ROLE_UPDATE"] = "BASE_ROLE_UPDATE";
    MailEvent["BASE_INVITE"] = "BASE_INVITE";
    MailEvent["WELCOME"] = "WELCOME";
    MailEvent["FORM_SUBMISSION"] = "FORM_SUBMISSION";
    MailEvent["RESET_PASSWORD"] = "RESET_PASSWORD";
    MailEvent["VERIFY_EMAIL"] = "VERIFY_EMAIL";
    MailEvent["ORGANIZATION_INVITE"] = "ORGANIZATION_INVITE";
    MailEvent["ORGANIZATION_ROLE_UPDATE"] = "ORGANIZATION_ROLE_UPDATE";
    MailEvent["ROW_USER_MENTION"] = "ROW_USER_MENTION";
    MailEvent["WORKSPACE_INVITE"] = "WORKSPACE_INVITE";
    MailEvent["WORKSPACE_ROLE_UPDATE"] = "WORKSPACE_ROLE_UPDATE";
    MailEvent["WORKSPACE_REQUEST_UPGRADE"] = "WORKSPACE_REQUEST_UPGRADE";
    MailEvent["TEAM_MEMBER_INVITE"] = "TEAM_MEMBER_INVITE";
    MailEvent["TEAM_MEMBER_ROLE_UPDATE"] = "TEAM_MEMBER_ROLE_UPDATE";
    MailEvent["TEAM_MEMBER_REMOVED"] = "TEAM_MEMBER_REMOVED";
    MailEvent["TEAM_ASSIGNED_TO_WORKSPACE"] = "TEAM_ASSIGNED_TO_WORKSPACE";
    MailEvent["TEAM_ASSIGNED_TO_BASE"] = "TEAM_ASSIGNED_TO_BASE";
    MailEvent["WORKSPACE_TEAM_REMOVED"] = "WORKSPACE_TEAM_REMOVED";
    MailEvent["WORKSPACE_TEAM_ROLE_UPDATE"] = "WORKSPACE_TEAM_ROLE_UPDATE";
    MailEvent["BASE_TEAM_REMOVED"] = "BASE_TEAM_REMOVED";
    MailEvent["BASE_TEAM_ROLE_UPDATE"] = "BASE_TEAM_ROLE_UPDATE";
    MailEvent["WORKFLOW_ERROR_DIGEST"] = "WORKFLOW_ERROR_DIGEST";
    MailEvent["SEND_RECORD"] = "SEND_RECORD";
    return MailEvent;
}(MailEvent || {});
